import React, { Component } from 'react';
import { uniqueId } from 'lodash/fp';
import { Icon } from 'ui';
import ClickAwayListener from 'components/shared/ClickAwayListener';

class ContentOptions extends Component {
  constructor(props) {
    super(props);
    this.state = { active: false };
    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
  }

  showMenu() {
    this.setState({ active: true });
  }

  hideMenu() {
    this.setState({ active: false });
  }

  static Option({ label, onClick, icon }) {
    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
      <li className="NewDropDown-item" onClick={onClick}>
        {icon && <Icon name={icon} className="mr-4" />}
        {label}
      </li>
    );
  }

  renderOptions() {
    return this.props.options.map(option => (
      <ContentOptions.Option {...option} key={uniqueId('option')} />
    ));
  }

  render() {
    return (
      <div className="PathContentOptions ml-8">
        <Icon
          name="ellipsis-v"
          className="PathContentOptions-toggle"
          onClick={this.showMenu}
        />
        {this.state.active && (
          <ClickAwayListener
            onClickAway={() => this.hideMenu()}
            touchEvent={false}
          >
            <ul
              className="NewDropDown-list NewDropDown-list--small Animated Animated--popDown"
              ref={node => {
                this.menu = node;
              }}
              children={this.renderOptions()}
            />
          </ClickAwayListener>
        )}
      </div>
    );
  }
}

export default ContentOptions;
